import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';

const RequestBook = () =>{

    const [isLoading, setIsLoading] = useState(false);
    const [TypeofCustomer, setTypeofCustomer] = useState('');
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [ContactNo, setContactNo] = useState('');
    const [Message, setMessage] = useState('');
    const [Quantity, setQuantity] = useState('');
    const [ShowAlert, setShowAlert] = useState(false);
    const [BookTitle,setBookTitle]= useState('');
    const [AdditionalNote, setAdditionalNote] = useState('');

    const isValid = () => {
        
        var result: Boolean = true;

        if (!Name) {
            result = false;
        }

        if (!Email) {
            result = false;
        }

        if (!ContactNo) {
            result = false;
        }

        if (!BookTitle) {
            result = false;
        }

        return result;
    }


    const SendMail = () => {
        
        if (!isValid()) {
            alert('Please fill all required fields');
            return false;
        }



        setIsLoading(true);
        const data = {
            Name: Name,
            Email: Email,
            PhoneNo: ContactNo,
            BookTitle: BookTitle,
            AdditionalNote: AdditionalNote
        }
        
        apiPost("api/Email/RequestBook", data).then((res: any) => {
            
            setName('');
            setEmail('');
            setContactNo('');
            setBookTitle('');
            setAdditionalNote('');

            setIsLoading(false);
            setShowAlert(true);
        });
    }



    return(<> 

{(isLoading && <Spinner></Spinner>)}
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/request-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

 {/* <!-- Contact Section Start --> */}
    <section className="contact-section fix section-padding">
        <div className="container">
            <div className="contact-wrapper">
                <div className="row g-4">
                    <div className="col-lg-6">
                        <div className="contact-left-items">
							<h2 className="wow fadeInUp mb-2" data-wow-delay=".3s">Request a Book Here:-</h2>
                          <p className="wow fadeInUp" data-wow-delay=".5s">Looks like the book you were looking for is currently not available in our store. Please fill up the form with essential details such as your name, email ID, phone number, Book Title, Description (optional). We will get back to you as soon as possible. We will try our best to provide the book at a best price. As soon as we procure the item for you, we will inform you by email or call. Placing a request does not mean that you are compelled to buy the book. If the book is meeting our requirement, we may a well add it to our store collection.</p>
                           
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="contact-content">
                            
                           
                            <form action="#" id="contact-form" method="POST" className="contact-form-items">
                                <div className="row g-4">
								
                                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                        <div className="form-clt">
                                            <span>Name*</span>
                                            <input type="text" name="name" value={Name} onChange={(e: any) => { setName(e.target.value) }} id="name" placeholder=""/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                        <div className="form-clt">
                                            <span>Email*</span>
                                            <input type="text" name="email" value={Email} onChange={(e: any) => { setEmail(e.target.value) }} id="email" placeholder=""/>
                                        </div>
                                    </div>
									 <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                        <div className="form-clt">
                                            <span>Phone No.*</span>
                                            <input type="number" name="phone"  value={ContactNo}  onChange={(e: any) => { setContactNo(e.target.value) }}  id="phone" placeholder=""/>
                                        </div>
                                    </div>
									 <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                        <div className="form-clt">
                                            <span>Book Title*</span>
                                            <input type="text" name="title"  value={BookTitle}  onChange={(e: any) => { setBookTitle(e.target.value) }} id="title" placeholder=""/>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 wow fadeInUp" data-wow-delay=".7s">
                                        <div className="form-clt">
                                            <span>Additional Note(Optional)</span>
                                            <textarea name="message" id="message" value={AdditionalNote}  onChange={(e: any) => { setAdditionalNote(e.target.value) }}
                                                placeholder=""></textarea>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 wow fadeInUp" data-wow-delay=".9s">
                                        {/* <button type="submit" onClick={SendMail} className="theme-btn">
                                            Send Message <i className="fa-solid fa-arrow-right-long"></i>
                                        </button> */}
                                        <button type="button" onClick={SendMail} className="theme-btn">
                                                Send Message <i className="fa-solid fa-arrow-right-long"></i>
                                            </button>
                                    </div>
                                    <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                            {ShowAlert && <div className="alert alert-success">
                                                Thanks for contacting us. We will get back to you at the earliest.
                                            </div>}
                                        </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

   

    </>);

}

export default RequestBook;